export default "__VITE_ASSET__DFlbFolu__"